import React from 'react';

export interface EmojiProps{
    label?: string;
    symbol?: string;
}

const Emoji = (props: EmojiProps) => (
    <span
        className="emoji"
        role="img"
        aria-label={props.label ? props.label : ""}
        aria-hidden={props.label ? "false" : "true"}
    >
        {props.symbol}
    </span>
);
export default Emoji;